import { render, staticRenderFns } from "./field-select-activity.component.vue?vue&type=template&id=07b6555c&scoped=true&"
import script from "./field-select-activity.component.vue?vue&type=script&lang=ts&"
export * from "./field-select-activity.component.vue?vue&type=script&lang=ts&"
import style0 from "./field-select-activity.component.vue?vue&type=style&index=0&id=07b6555c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6555c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
